import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PickingProductivityRoutingModule } from "./picking-productivity-routing.module";
import { PickingProductivityComponent } from "./picking-productivity.component";
import { PickingProductivityFilterComponent } from "./picking-productivity-filter/picking-productivity-filter.component";
import { PickingProductivityContentComponent } from "./picking-productivity-content/picking-productivity-content.component";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { PickingProductivityService } from '../../core';
import { SharedModule, } from '../../shared';
import { PickingProductivityTableComponent } from './picking-productivity-table/picking-productivity-table.component';
import { DateRangeComponent } from "../../shared/components/date-range/date-range.component";

@NgModule({
  declarations: [
    PickingProductivityComponent,
    PickingProductivityFilterComponent,
    PickingProductivityContentComponent,
    PickingProductivityTableComponent
  ],
  imports: [
    CommonModule,
    PickingProductivityRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    HttpClientModule,
    DateRangeComponent
  ],
  providers: [PickingProductivityService]
})
export class PickingProductivityModule { }
